export default "__VITE_ASSET__0b52d844__"